import { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { keycloak } from '../keycloak';

const KeycloakContext = createContext({ keycloak: null, initialized: false });

const saveTokens = () => {
  if (keycloak.token) localStorage.setItem('kc_token', keycloak.token);
  if (keycloak.refreshToken) localStorage.setItem('kc_refreshToken', keycloak.refreshToken);
  if (keycloak.idToken) localStorage.setItem('kc_idToken', keycloak.idToken);
};

const clearTokens = () => {
  localStorage.removeItem('kc_token');
  localStorage.removeItem('kc_refreshToken');
  localStorage.removeItem('kc_idToken');
};

export const KeycloakProvider = ({ children }) => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('kc_token');
    const refreshToken = localStorage.getItem('kc_refreshToken');

    const initOptions = {
      checkLoginIframe: false,
      pkceMethod: 'S256',
    };
    if (token && refreshToken) {
      initOptions.token = token;
      initOptions.refreshToken = refreshToken;
    }

    keycloak.onAuthSuccess = saveTokens;
    keycloak.onAuthRefreshSuccess = saveTokens;
    keycloak.onAuthLogout = clearTokens;
    keycloak.onAuthError = clearTokens;

    keycloak.init(initOptions).finally(() => {
      setInitialized(true);
    });

    return () => {
      keycloak.onAuthSuccess = undefined;
      keycloak.onAuthRefreshSuccess = undefined;
      keycloak.onAuthLogout = undefined;
      keycloak.onAuthError = undefined;
    };
  }, []);

  const value = { keycloak, initialized };

  return (
    <KeycloakContext.Provider value={value}>
      {children}
    </KeycloakContext.Provider>
  );
};

KeycloakProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useKeycloakAuth = () => useContext(KeycloakContext);

export default KeycloakContext;
